import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
export const getAllData = createAsyncThunk('appDriverEarnings/GetDriverEarnings', async (GetDriver) => {
     
    const response = await axios.post(' https://api.zasway.com:8443/Driver/GetDriverEarnings', GetDriver, {mode:'cors'})
     
    return response.data
    })
    export const getAverageEarning = createAsyncThunk('appDriverEarnings/GetDriverEarningsAverage', async (GetDriver) => {
       
      const response = await axios.post(' https://api.zasway.com:8443/Driver/GetDriverEarningsAverage', GetDriver, {mode:'cors'})
      
      return response.data
      })
    export const appDriverEarningsSlice = createSlice({
        name: 'appDriverEarnings',
        initialState: {
          data: []
         
        },
        reducers: {}
        // extraReducers: builder => {
        //   builder
        //   // .addCase(getData.fulfilled, (state, action) => {
        //   //    state.allData = action.payload.allData
        //   //   state.data = action.payload.data
        //   // })
        // }
      })
       export default appDriverEarningsSlice.reducer